import { useEffect, useCallback, useState, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Grid, Button, CircularProgress, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { SelectField, TextField, DateTimePicker, MultilineField, Dialog } from 'style-guide';

import { STATUS } from 'constants/global-constants';
import { REQUEST_ACTIONS, sendRequest } from 'utils/Communicator';

import { useDispatch, useSelector } from 'react-redux';
import { getOrders } from 'reducers/order-reducers/ordersSlicer';
import { snackbarToggle } from 'reducers/snackbarSlicer';
import CustomsUIItems from './CustomsUIItems';
import CustomsUIError from './CustomsUIError';
import IosShareIcon from '@mui/icons-material/IosShare';
import CheckIcon from '@mui/icons-material/Check';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';

const CustomsUISet = ({ fileCodes, loginUser, order, data, index, updateData, saveCustomsUIData, saveCustomsUIData1, setCustomsUiData, setOrder, setLoader, showItems, setShowItems, statuses }) => {
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);

    const statusesFU = [
        { id: null, name: "Reset" },
        { id: 1, name: "Files Uploaded" },
    ];
    const statusesCust = [
        { id: null, name: "Reset" },
        { id: 2, name: "Completed" },
    ];
    const statusesOff = [
        { id: null, name: "Reset" },
        { id: 3, name: "Reject" },
        { id: 4, name: "Approve" },
    ];

    const fileInputHAWBRef = useRef(null);
    const fileInputINVRef = useRef(null);
    const fileInputPLRef = useRef(null);


    const [matched, setMatched] = useState(null);
    const [different, setDifferent] = useState(null);
    const [filesNum, setFilesNum] = useState(null);

    const [showINVFiles, setShowINVFiles] = useState(true);
    const [showPLFiles, setShowPLFiles] = useState(true);
    const [showCrossErrors, setShowCrossErrors] = useState(true);

    const [errorsCross, setErrorsCross] = useState([]);
    const [details, setDetails] = useState([]);

    const fields = [
        "consignee_name",
        "package_count",
        "total_packages",
        "gross_weight",
        "total_gross_weight",
        "consignee_address",
        "shipper_name",
        "shipper_address",
        "invoice_number",
        "invoice_reference",
        "invoice_date",
        "bl_number",
        "bl_date",
        "bl_type",
        "order_number",
        "total_value",
        "currency",
        "incoterms",
        "seal_number",
        "container_number",
        "volumetric_weight",
        "total_volumetric_weight",
        "market_declaration",
        "country_of_origin",
    ]
    useEffect(() => {
        var errs = [];
        var dts = [];
        if (data?.aiData?.cross_validation?.checks) {
            for (var i = 0; i < data?.aiData?.cross_validation?.checks.length; i++) {
                if (data?.aiData?.cross_validation?.checks[i].status != "PASS")
                    errs.push(["Cross Check", data?.aiData?.cross_validation?.checks[i].message, data?.aiData?.cross_validation?.checks[i].explanation]);
            }
        }
        if (data?.aiData?.file_validation) {
            if (data?.aiData?.file_validation?.bill_of_lading) {
                for (var i = 0; i < data.aiData.file_validation.bill_of_lading.errors.length; i++) {
                    errs.push([data.aiData.file_validation.bill_of_lading.file_name, data.aiData.file_validation.bill_of_lading.errors[i]]);
                }
                //dts.push(data.aiData.file_validation.bill_of_lading);
            }
            if (data?.aiData?.file_validation?.invoices) {
                for (var i = 0; i < data.aiData.file_validation.invoices.length; i++) {
                    for (var j = 0; j < data.aiData.file_validation.invoices[i].errors.length; j++) {
                        errs.push([data.aiData.file_validation.invoices[i].file_name, data.aiData.file_validation.invoices[i].errors[j]]);
                    }
                    //dts.push(data.aiData.file_validation.invoices[i]);
                }
            }
            if (data?.aiData?.file_validation?.packing_lists) {
                for (var i = 0; i < data.aiData.file_validation.packing_lists.length; i++) {
                    for (var j = 0; j < data.aiData.file_validation.packing_lists[i].errors.length; j++) {
                        errs.push([data.aiData.file_validation.packing_lists[i].file_name, data.aiData.file_validation.packing_lists[i].errors[j]]);
                    }
                    //dts.push(data.aiData.file_validation.packing_lists[i]);
                }
            }
        }
        /*if (data.fileData) {
            var keys = Object.keys(data.fileData);
            var maxLen = 0;
            for (var i = 0; i < keys.length; i++) {
                var keysInt = Object.keys(data.fileData[keys[i]]);
                if (keysInt.length > maxLen)
                    maxLen = keysInt.length;
            }
            for (var i = 0; i < keys.length; i++) {
                var objs = [];
                var keysInt = Object.keys(data.fileData[keys[i]]);
                for (var j = 0; j < keysInt.length; j++) {
                    objs.push({ value: data.fileData[keys[i]][keysInt[j]], label: keysInt[j] });
                }
                for (var j = keysInt.length; j < maxLen; j++) {
                    objs.push({ value: "", label: "" });
                }
                dts.push({ fields: objs, file_name: keys[i], data: data.fileData[keys[i]] });
            }
        }*/
        if (data.fileData) {
            var keys = Object.keys(data.fileData);
            const priority = { 'bl_': 1, 'inv_': 2, 'pl_': 3 };
            keys.sort((a, b) => {
                var prefixA = a.substring(0, 4);
                if (prefixA != "inv_")
                    prefixA = a.substring(0, 3);
                var prefixB = b.substring(0, 4);
                if (prefixB != "inv_")
                    prefixB = b.substring(0, 3);
                const weightA = priority[prefixA] || 99;
                const weightB = priority[prefixB] || 99;
                if (weightA !== weightB) {
                    return weightA - weightB;
                }
                return a.localeCompare(b);
            });
            setFilesNum(keys.length);
            //var dt_headers = ["Fields", "Result"];
            var dt_headers = ["Fields"];
            for (var i = 0; i < keys.length; i++) {
                dt_headers.push(keys[i]);
            }
            dts.push(dt_headers);
            for (var j = 0; j < fields.length; j++) {
                var objs = [];
                objs.push(fields[j]);
                for (var i = 0; i < keys.length; i++) {
                    if (data.fileData[keys[i]][fields[j]])
                        objs.push(data.fileData[keys[i]][fields[j]]);
                    else
                        objs.push("");
                }
                dts.push(objs);
            }
        }
        setErrorsCross(errs);
        setDetails(dts);
        var mat = 0;
        var diff = 0;
        for (var k = 0; k < dts.length; k++) {
            var res = statusFromGrid(errs, k);
            if (res == 1) {
                diff++;
            } else if (res == 2) {
                mat++;
            }
        }
        setMatched(mat);
        setDifferent(diff);
    }, [data]);

    const statusFromGrid = (errs, row) => {
        if (row == 1) {
            for (var i = 0; i < errs.length; i++) {
                if (errs[i][2]?.includes("Consignee")) {
                    return 1;
                }
            }
            return 2;
        }
        if (row == 2 || row == 3) {
            for (var i = 0; i < errs.length; i++) {
                if (errs[i][2]?.includes("Package count mismatch")) {
                    return 1;
                }
            }
            return 2;
        }
        if (row == 4 || row == 5) {
            for (var i = 0; i < errs.length; i++) {
                if (errs[i][2]?.includes("Gross weight deviation")) {
                    return 1;
                }
            }
            return 2;
        }
        return 0;
    }

    const exportCSV = () => {
        alert("Export CSV!");
    }
    const items = () => {
        setShowItems(true);
    }
    const closeitems = () => {
        setShowItems(false);
    }
    const verify = (id) => {
        if (data.verifing) {
            alert("Set is being worked on, please wait.");
            return;
        }
        if (fileNum(7) == 1 && fileNum(2) >= 1 && fileNum(11) >= 0) {
            sendRequest('/api/customsUI/verify?orderId=' + order.id + "&setId=" + id, REQUEST_ACTIONS.POST, '', {
                loginUser: loginUser,
                successCallback: response => {
                    if (response)
                        setCustomsUiData(response);
                },
                failedCallback,
            });
        } else {
            alert("Please make sure you have uploaded 1 HAWB, atleast 1 invoice before you verify.");
        }
    }
    const loadHSCode = (id) => {
        if (fileNum(7) == 1 && fileNum(2) >= 1 && fileNum(11) >= 0) {
            sendRequest('/api/customsUI/loadHSCodes?orderId=' + order.id + "&setId=" + id, REQUEST_ACTIONS.POST, '', {
                loginUser: loginUser,
                successCallback: response => {
                    if (response)
                        setCustomsUiData(response);
                },
                failedCallback,
            });
        } else {
            alert("Please make sure you have uploaded 1 HAWB, atleast 1 invoice before you verify.");
        }
    }
    const verifydb = (id) => {
        if (data.verifing) {
            //alert("Set is being worked on, please wait.");
            alert("Files processing already running, are you sure?");
            return;
        }
        if (fileNum(7) == 1 && fileNum(2) >= 1 && fileNum(11) >= 0 ) {
            if (fileNum(2) > 1 && fileNum(11) == 0) {
                alert("More than 1 invoice requies at least 1 Package list file.");
                return;
            } else {
                sendRequest('/api/customsUI/verifydb?orderId=' + order.id + "&setId=" + id + "&user=" + loginUser.id, REQUEST_ACTIONS.POST, '', {
                    loginUser: loginUser,
                    successCallback: response => {
                        if (response)
                            setCustomsUiData(response);
                    },
                    failedCallback,
                });
            }
        } else {
            alert("Please make sure you have uploaded 1 HAWB, atleast 1 invoice before you verify.");
        }
    }
    const getFileCodes = (codeId) => {
        const code = fileCodes.find(code => code.id === codeId);
        return code?.name?.replace(/ /g, "_")?.toUpperCase();
    }
    const fileNum = (type) => {
        var count = 0;
        for (var i = 0; i < order.orderStage[4].archives.length; i++) {
            if (order.orderStage[4].archives[i].codeId == type && data.id == order.orderStage[4].archives[i].sid) {
                count++;
            }
        }
        return count;
    }
    const saveCurrentSet = () => {
        saveCustomsUIData(data.id);
    }
    const saveCurrentSetTimer = () => {
        const myTimeout = setTimeout(saveCurrentSet, 100);
    }
    const hawbFileHandler = (event) => {
        if (event.preventDefault) event.preventDefault();
        if (event.stopPropagation) event.stopPropagation();

        const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        if (!files || files.length === 0) return;

        if (fileNum(7) > 0) {
            if (confirm("AWB/HAWB file already uploaded, are you sure you want to remove it?")) {
                try {
                    var file1 = data.fileData?.find(f => f.codeId == 7);
                    if (file1)
                        removeFileWithoutPrompt(file1);
                    else
                        removeFileWithoutPrompt(null);
                } catch (e) {
                    removeFileWithoutPrompt(null);
                    console.log(e);
                }
            } else {
                return;
            }
        }

        setLoader(true);
        var codeId = 7; // hawb: 7, PL: 11, inv: 2
        var orderStageId = order.orderStage[4].id;
        const file = files[0];
        const time_now = new Date().toLocaleString("en-EN", { timeZone: 'Israel' }).split(",");
        const cur_date = time_now[0].split("/");
        const file_ext = file.name.split(".");
        const ext = file_ext[file_ext.length - 1];
        const show_name = "" + getFileCodes(codeId) + "_" + cur_date[0] + "_" + cur_date[1] + "_" + cur_date[2] + "_" + new Date(time_now).getTime() + "." + ext;
        const codeFileName = {
            codeId,
            fileName: show_name,
        };
        const formData = new FormData();
        formData.append('code', JSON.stringify([codeFileName]));

        formData.append('files', file, show_name);
        formData.append('orgName', file.name);
        formData.append('orderStageId', orderStageId);
        formData.append('orderId', order.id);
        formData.append('loginUserId', loginUser.id);
        formData.append('sId', data.id);

        sendRequest('/api/upload', REQUEST_ACTIONS.POST, formData, {
            successCallback: message => {
                setOrder(message);
                if (fileInputHAWBRef.current) {
                    fileInputHAWBRef.current.value = "";
                }
                setLoader(false);
            },
            failedCallback,
        });
    }
    const uploadFormData = (forms, i, tot, callback, callbackEnd) => {
        if (i < tot) {
            const time_now = new Date().toLocaleString("en-EN", { timeZone: 'Israel' }).split(",");
            const cur_date = time_now[0].split("/");
            var time_n = new Date(time_now).getTime();
            time_n += i;
            const show_name = "" + getFileCodes(forms[i].codeId) + "_" + cur_date[0] + "_" + cur_date[1] + "_" + cur_date[2] + "_" + time_n + "." + forms[i].ext;
            var codeId = forms[i].codeId;
            var codeFileName = {
                codeId,
                fileName: show_name,
            };
            forms[i].show_name = show_name;
            const formData = new FormData();
            formData.append('code', JSON.stringify([codeFileName]));

            formData.append('files', forms[i].file, show_name);
            formData.append('orgName', forms[i].orgName);
            formData.append('orderStageId', forms[i].orderStageId);
            formData.append('orderId', forms[i].orderId);
            formData.append('loginUserId', forms[i].loginUserId);
            formData.append('sId', data.id);
            sendRequest('/api/upload', REQUEST_ACTIONS.POST, formData, {
                successCallback: message => {
                    setOrder(message);
                    callback(forms, i + 1, tot, callback, callbackEnd);
                    // get file data and set it
                },
                failedCallback,
            });
        } else {
            callbackEnd();
        }
    }
    const invFileHandler = (event) => {
        if (event.preventDefault) event.preventDefault();
        if (event.stopPropagation) event.stopPropagation();

        setLoader(true);
        var codeId = 2; // inv: 2
        var orderStageId = order.orderStage[4].id;
        var forms = [];
        var files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        if (!files) return;

        for (var i = 0; i < files.length; i++) {
            const file = files[i];
            const file_ext = file.name.split(".");
            const ext = file_ext[file_ext.length - 1];
            var form = {};
            form.codeId = codeId;
            form.orgName = file.name;
            form.ext = ext;
            form.file = file;
            form.orderStageId = orderStageId;
            form.orderId = order.id;
            form.loginUserId = loginUser.id;
            forms.push(form);
        }
        uploadFormData(forms, 0, files.length, uploadFormData, function () {
            setLoader(false);
            if (fileInputINVRef.current) {
                fileInputINVRef.current.value = "";
            }
        });
    }
    const plFileHandler = (event) => {
        if (event.preventDefault) event.preventDefault();
        if (event.stopPropagation) event.stopPropagation();

        setLoader(true);
        var codeId = 11; // PL: 11
        var orderStageId = order.orderStage[4].id;
        var forms = [];
        var files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
        if (!files) return;

        for (var i = 0; i < files.length; i++) {
            const file = files[i];
            const file_ext = file.name.split(".");
            const ext = file_ext[file_ext.length - 1];
            var form = {};
            form.codeId = codeId;
            form.orgName = file.name;
            form.ext = ext;
            form.file = file;
            form.orderStageId = orderStageId;
            form.orderId = order.id;
            form.loginUserId = loginUser.id;
            forms.push(form);
        }
        uploadFormData(forms, 0, files.length, uploadFormData, function () {
            setLoader(false);
            if (fileInputPLRef.current) {
                fileInputPLRef.current.value = "";
            }
        });
    }
    const removeFile = (file) => {
        if (confirm("Are you sure you want to remove the file?")) {
            setLoader(true);
            sendRequest(`/api/files/${order.orderStage[4].archives?.find(f => f.name === file.name)?.id}/${loginUser.id}/${order.id}/${file.name}`, REQUEST_ACTIONS.DELETE, '', {
                successCallback: (message) => {
                    updateOrder();
                },
                failedCallback,
            });
        }
    }
    const removeFilesWithoutPrompt = (file) => {
        setLoader(true);
        if (!file) {
            var f = order.orderStage[4].archives?.find(f => f.codeId === 7);
            file = { codeId: 7, file: f.name };
        }
        sendRequest(`/api/files/${order.orderStage[4].archives?.find(f => f.name === file.file)?.id}/${loginUser.id}/${order.id}/${file.file}`, REQUEST_ACTIONS.DELETE, '', {
            successCallback: (message) => {
                updateOrder();
            },
            failedCallback,
        });
    }
    const removeFileWithoutPrompt = (file) => {
        setLoader(true);
        if (!file) {
            var f = order.orderStage[4].archives?.filter(f => f.codeId === 7);
            for (var i = 0; i < f.length; i++) {
                file = { codeId: 7, file: f[i].name };
                sendRequest(`/api/files/${order.orderStage[4].archives?.find(f => f.name === file.file)?.id}/${loginUser.id}/${order.id}/${file.file}`, REQUEST_ACTIONS.DELETE, '', {
                    successCallback: (message) => {
                        updateOrder();
                    },
                    failedCallback,
                });
            }
            
        }
    }

    const updateOrder = () => {
        sendRequest(`/api/order/${order.id}`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                setOrder(response);
                setLoader(false);
            },
            failedCallback,
        });
    }

    const [dragActive, setDragActive] = useState(false);
    const [files, setFiles] = useState([]);
    const inputRef = useRef(null);

    // Handle drag events
    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    // Handle dropped files
    const onDrop = useCallback(acceptedFiles => {
        //console.log("/api/emptyData")
        for (var i = 0; i < acceptedFiles.length; i++) {
            if (acceptedFiles[i].size > 5242880) {
                dispatch(snackbarToggle({ type: 'error', message: 'File size should be less than 5MB' }));
                return;
            }
        }
        dispatch(snackbarToggle({ type: 'success', message: 'File size is less than 5MB' }));

    }, []);
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const droppedFiles = Array.from(e.dataTransfer.files);
            setFiles(droppedFiles);
            console.log("Dropped files:", droppedFiles);
        }
    };

    const handleDropINV = (e) => {
        /*e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const droppedFiles = Array.from(e.dataTransfer.files);
            setFiles(droppedFiles);
            console.log("Dropped files:", droppedFiles);
        }*/

        setLoader(true);
        var codeId = 2; // hawb: 7, PL: 11, inv: 2
        var orderStageId = order.orderStage[4].id; // set proper stage id
        var forms = [];
        var files = e.dataTransfer.files;
        for (var i = 0; i < files.length; i++) {
            const file = files[i];
            const file_ext = file.name.split(".");
            const ext = file_ext[1];
            var form = {};
            form.codeId = codeId;
            form.ext = ext;
            form.file = file;
            form.orderStageId = orderStageId;
            form.orderId = order.id;
            form.loginUserId = loginUser.id;
            forms.push(form);
        }
        uploadFormData(forms, 0, files.length, uploadFormData, function () {
            setLoader(false);
            if (fileInputINVRef.current) {
                fileInputINVRef.current.value = ""; // Resets the input
            }
        });
    };
    const onButtonClickInvoice = () => {
        fileInputINVRef.current.click();
    };
    const onButtonClickPL = () => {
        fileInputPLRef.current.click();
    };
    const onButtonClickHAWB = () => {
        fileInputHAWBRef.current.click();
    };

    return (
        <Grid item container style={{ borderTop: `${index != 1 ? "none" : "1px grey solid"}`, padding: "10px 20px" }}>
            {showItems && <Dialog maxWidth='100vw' width="1600px" open={showItems} onHandleCancel={closeitems} title={'Items'}>
                <CustomsUIItems
                    order={order}
                    loginUser={loginUser}
                    data1={data}
                    data1Org={JSON.parse(JSON.stringify(data))}
                    index={data.id}
                    updateData1={updateData}
                    setCustomsUiData={setCustomsUiData}
                    saveCustomsUIData={saveCustomsUIData} />
            </Dialog>}
            <Grid item container style={{ margin: "10px", background: "white", borderRadius: "9px" }} alignItems="center">
                <Grid item container style={{ margin: "10px" }} alignItems="center">
                    <TextField
                        lg={2.4}
                        style={{ paddingLeft: "5px" }}
                        type="Text"
                        label='Set Name'
                        value={data.setDesc}
                        onChange={event => {
                            var dt = JSON.parse(JSON.stringify(data));
                            dt.setDesc = event.target.value;
                            updateData(dt);
                        }}
                    />
                    <TextField
                        lg={2.4}
                        style={{ padding: "5px" }}
                        type="Text"
                        label='HAWB / SHIPMENT NUMBER'
                        value={data.hawb ? data.hawb : (order.orderStage[4].departureStage[0]?.house ? order.orderStage[4].departureStage[0]?.house : null)}
                        onChange={event => {
                            var dt = JSON.parse(JSON.stringify(data));
                            dt.hawb = event.target.value;
                            updateData(dt);
                        }}
                    />
                    <TextField
                        lg={2.4}
                        readOnly
                        style={{ padding: "5px" }}
                        type="Text"
                        label='Order'
                        value={order.jobNumber}
                        onChange={event => {
                        }}
                    />
                    <SelectField
                        label='STATUS'
                        lg={2.4}
                        value={data.status}
                        onChange={event => {
                            var dt = JSON.parse(JSON.stringify(data));
                            dt.status = event.target.value;
                            updateData(dt);
                        }}
                        options={loginUser.authority === "Admin" ? statuses : (loginUser.department == 1 ? statusesFU : (loginUser.department == 3 ? statusesCust : (loginUser.department == 5 ? statusesOff : [])))}
                    />
                    <Grid item container lg={2.4} justifyContent="flex-end">
                        {<Button
                            variant='contained'
                            style={{
                                border: "1px solid #0b5cab",
                                borderRadius: "5px",
                                padding: "5px 8px",
                                margin: "0 10px",
                                background: "linear-gradient(#1682cf, #0965ae)",
                                color: "#fff",
                                fontWeight: "700",
                                fontSize: "14px",
                                cursor: "pointer"
                            }}
                            onClick={() => { verifydb(data.id); }}>
                            {data.verifing ? <CircleOutlinedIcon style={{ margin: "0 5px", color: "orange" }} /> : (data.verified ? <CheckIcon style={{ margin: "0 5px" }} /> : "")}
                            Process Files
                        </Button>}
                        {<Button
                            variant='contained'
                            style={{
                                border: "1px solid #0b5cab",
                                borderRadius: "5px",
                                padding: "5px 8px",
                                margin: "0 10px",
                                background: "linear-gradient(#1682cf, #0965ae)",
                                color: "#fff",
                                fontWeight: "700",
                                fontSize: "14px",
                                cursor: "pointer"
                            }}
                            onClick={() => {
                                saveCustomsUIData(data.id)
                            }}>
                            Save Changes
                        </Button>}
                    </Grid>
                </Grid>
                <Grid item container flexWrap="nowrap" style={{ margin: "10px" }} >
                    <MultilineField
                        required
                        xs={12}
                        sm={null}
                        md={null}
                        lg={null}
                        label='Comments'
                        value={data.comments}
                        onChange={event => {
                            var dt = JSON.parse(JSON.stringify(data));
                            dt.comments = event.target.value;
                            updateData(dt);
                        }}
                    />
                </Grid>
                <Grid item container flexWrap="nowrap" style={{ marginTop: "10px" }} >
                    <Grid item container style={{ border: "1px #cdd9e2 solid", borderRadius: "5px", padding: "5px", margin: "10px" }} flexDirection="row" flexWrap="nowrap">
                        <div style={{ width: "100%", display: "block", overflowY: "auto", overflowX: "hidden" }}>
                            <table style={{ margin: "5px", width: "calc(100% - 5px)" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ backgroundColor: "#fff", textAlign: "left" }}>
                                            <Grid item container justifyContent="center">
                                                <div
                                                    className={`drop-zone`}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    onDrop={hawbFileHandler}
                                                    onClick={onButtonClickHAWB}
                                                    style={{
                                                        border: `2px dashed #4A90E2}`,
                                                        padding: "10px",
                                                        textAlign: "center",
                                                        borderRadius: "8px",
                                                        background: "#f8fbfd",
                                                        cursor: "pointer",
                                                        width: "100%"
                                                    }}
                                                >
                                                    {/* Hidden file input */}
                                                    <input
                                                        ref={fileInputHAWBRef}
                                                        type="file"
                                                        multiple
                                                        onChange={hawbFileHandler}
                                                        style={{ display: "none" }}
                                                    />

                                                    <p style={{ width: "100%", padding: "0" }}>Upload <strong>HAWB</strong> here </p>
                                                    <IosShareIcon style={{ marginBottom: "10px" }} />

                                                    {/*{files.length > 0 && (
                                                        <div style={{ marginTop: "15px", textAlign: "left" }}>
                                                            <strong>Selected Files:</strong>
                                                            <ul>
                                                                {files.map((file, idx) => <li key={idx}>{file.orgName ? file.orgName : file.name}</li>)}
                                                            </ul>
                                                        </div>
                                                    )}*/}
                                                </div>
                                            </Grid>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {showPLFiles && <Grid item container alignContent="flex-start" style={{ marginTop: "10px" }}>
                                                {order.orderStage[4].archives?.filter(f => f.codeId == 7 && f.sid == data.id)?.map(file => (<Grid lg={11} item container style={{ overflow: "hidden" }} justifyContent="flex-start" flexWrap="nowrap">
                                                    <div onClick={() => { removeFile(file) }} style={{ marginRight: "10px", paddingLeft: "20px", color: "#c53b3b" }}>X</div>
                                                    <div><a href={file.uri} style={{ color: "#315a78", fontSize: "14px" }} target="_blank">{file.orgName ? file.orgName?.slice(0, 40) : file.name?.slice(0, 40)}</a></div>
                                                </Grid>))}
                                            </Grid>}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Grid>
                    <Grid item container style={{ border: "1px #cdd9e2 solid", borderRadius: "5px", padding: "5px", margin: "10px" }} flexDirection="row" flexWrap="nowrap">
                        <div style={{ width: "100%", display: "block", overflowY: "auto", overflowX: "hidden" }}>
                            <table style={{ margin: "5px", textAlign: "center", width: "calc(100% - 5px)", overflow: "hidden" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ height: "30px", backgroundColor: "#fff", textAlign: "left" }}>
                                            <Grid item container justifyContent="center">
                                                <div
                                                    className={`drop-zone`}
                                                    onDrop={invFileHandler}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    //onDrop={handleDropINV}
                                                    onClick={onButtonClickInvoice}
                                                    style={{
                                                        border: `2px dashed #4A90E2}`,
                                                        padding: "10px",
                                                        textAlign: "center",
                                                        borderRadius: "8px",
                                                        background: "#f8fbfd",
                                                        cursor: "pointer",
                                                        width: "100%"
                                                    }}
                                                >
                                                    {/* Hidden file input */}
                                                    <input
                                                        ref={fileInputINVRef}
                                                        type="file"
                                                        multiple
                                                        onChange={invFileHandler}
                                                        style={{ display: "none" }}
                                                    />

                                                    <p style={{ width: "100%", padding: "0" }}>Upload <strong>Invoice</strong> here </p>
                                                    <IosShareIcon style={{ marginBottom: "10px" }} />

                                                </div>
                                                {/*<span style={{ marginBottom: "10px", fontWeight: "bold" }}>Invoice files
                                                    <label for="inv-file-upload" style={{ cursor: "pointer", padding: "8px" }}>...</label>
                                                    <input id="inv-file-upload" type="file" onChange={invFileHandler} ref={fileInputINVRef} multiple style={{ display: "none" }} />
                                                </span>*/}
                                            </Grid>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {showINVFiles && <Grid item container alignContent="flex-start" style={{ marginTop: "10px", height: "80px", overflow: "auto" }}>
                                                {order.orderStage[4].archives?.filter(f => f.codeId == 2 && f.sid == data.id)?.map(file => (<Grid lg={11} item container style={{ overflow: "hidden" }} justifyContent="flex-start" flexWrap="nowrap">
                                                    <div onClick={() => { removeFile(file) }} style={{ color: "#c53b3b", marginRight: "10px", paddingLeft: "20px" }}>X</div>
                                                    <div><a href={file.uri} style={{ color: "#315a78", fontSize: "14px" }} target="_blank">{file.orgName ? file.orgName?.slice(0, 40) : file.name?.slice(0, 40)}</a></div>
                                                </Grid>))}
                                            </Grid>}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Grid>
                    <Grid item container style={{ border: "1px #cdd9e2 solid", borderRadius: "5px", padding: "5px", margin: "10px" }} flexDirection="row" flexWrap="nowrap">
                        <div style={{ width: "100%", display: "block", overflowY: "auto", overflowX: "hidden" }}>
                            <table style={{ margin: "5px", textAlign: "center", width: "calc(100% - 5px)" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ backgroundColor: "#fff", textAlign: "left" }}>
                                            <Grid item container justifyContent="center">
                                                <div
                                                    className={`drop-zone`}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    onDrop={plFileHandler}
                                                    onClick={onButtonClickPL}
                                                    style={{
                                                        border: `2px dashed #4A90E2}`,
                                                        padding: "10px",
                                                        textAlign: "center",
                                                        borderRadius: "8px",
                                                        background: "#f8fbfd",
                                                        cursor: "pointer",
                                                        width: "100%"
                                                    }}
                                                >
                                                    {/* Hidden file input */}
                                                    <input
                                                        ref={fileInputPLRef}
                                                        type="file"
                                                        multiple
                                                        onChange={plFileHandler}
                                                        style={{ display: "none" }}
                                                    />

                                                    <p style={{ width: "100%", padding: "0" }}>Upload <strong>PL</strong> here </p>
                                                    <IosShareIcon style={{marginBottom: "10px"}} />

                                                </div>
                                                {/*<span style={{ marginBottom: "10px", fontWeight: "bold" }}>Packing List files
                                                    <label for="pl-file-upload" style={{ cursor: "pointer", padding: "8px" }}>...</label>
                                                    <input id="pl-file-upload" type="file" onChange={plFileHandler} ref={fileInputPLRef} multiple style={{ display: "none" }} />
                                                </span>*/}
                                            </Grid>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {showPLFiles && <Grid item container alignContent="flex-start" style={{ marginTop: "10px", height: "80px", overflow: "auto" }}>
                                                {order.orderStage[4].archives?.filter(f => f.codeId == 11 && f.sid == data.id)?.map(file => (<Grid lg={11} item container style={{ overflow: "hidden" }} justifyContent="flex-start" flexWrap="nowrap">
                                                    <div onClick={() => { removeFile(file) }} style={{ color: "#c53b3b", marginRight: "10px", paddingLeft: "20px" }}>X</div>
                                                    <div><a href={file.uri} style={{ color: "#315a78", fontSize: "14px" }} target="_blank">{file.orgName ? file.orgName?.slice(0, 40) : file.name?.slice(0, 40)}</a></div>
                                                </Grid>))}
                                            </Grid>}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item container style={{marginBottom: "10px"}} alignItems="center" justifyContent="flex-end">
                <Grid item container style={{ }} spacing={-1} justifyContent="space-between">
                    <Grid item container lg={2.9} flexDirection="column" flexWrap="nowrap" style={{ padding: "13px", background: "white", borderRadius: "9px", border: "1px solid #dce5ec", boxShadow: "0 2px 8px #1b496d0b"}}>
                        <p style={{ fontSize: "11px", padding: "2px", margin: "0 0 0 15px", color: "#708191" }}>VALIDATION STATUS</p>
                        <b style={{ fontSize: "19px", padding: "2px", margin: "0 0 0 15px" }}>{statuses.find(f => f.id == data.status)?.name}</b>
                    </Grid>
                    <Grid item container lg={2.9} flexDirection="column" flexWrap="nowrap" style={{ padding: "13px", background: "white", borderRadius: "9px", border: "1px solid #dce5ec", boxShadow: "0 2px 8px #1b496d0b" }}>
                        <p style={{ fontSize: "11px", padding: "2px", margin: "0 0 0 15px", color: "#708191" }}>MATCHED FIELDS</p>
                        <b style={{ fontSize: "19px", color: "#16834b", padding: "2px", margin: "0 0 0 15px" }}>{matched}</b>
                    </Grid>
                    <Grid item container lg={2.9} flexDirection="column" flexWrap="nowrap" style={{ padding: "13px", background: "white", borderRadius: "9px", border: "1px solid #dce5ec", boxShadow: "0 2px 8px #1b496d0b" }}>
                        <p style={{ fontSize: "11px", padding: "2px", margin: "0 0 0 15px", color: "#708191" }}>DIFFERENCES</p>
                        <b style={{ fontSize: "19px", color: "#c53b3b", padding: "2px", margin: "0 0 0 15px" }}>{different}</b>
                    </Grid>
                    <Grid item container lg={2.9} flexDirection="column" flexWrap="nowrap" style={{ padding: "13px", background: "white", borderRadius: "9px", border: "1px solid #dce5ec", boxShadow: "0 2px 8px #1b496d0b" }}>
                        <p style={{ fontSize: "11px", padding: "2px", margin: "0 0 0 15px", color: "#708191" }}>DOCUMENTS COMPARED</p>
                        <b style={{ fontSize: "19px", padding: "2px", margin: "0 0 0 15px" }}>{filesNum}</b>
                    </Grid>
                </Grid>
            </Grid>
            
            {showCrossErrors && <CustomsUIError data={errorsCross} details={details} orgData={data} />}
        </Grid>
    );
}


export default CustomsUISet;